import { isBefore, startOfDay } from 'app/lib/date';
import { isDonationListing } from 'app/lib/listing';
import type { Listing } from 'app/types/listing';
import { TransactionMode } from 'app/types/listing';

export function getListingLoanDateConstraints(listing?: Listing) {
  const minimumDate = listing?.start ? startOfDay(new Date(listing.start)) : undefined;
  const maximumDate = [listing?.end, listing?.before]
    .filter((date): date is string => Boolean(date))
    .map((date) => startOfDay(new Date(date)))
    .reduce<Date | undefined>((earliest, date) => (!earliest || isBefore(date, earliest) ? date : earliest), undefined);

  return { minimumDate, maximumDate };
}

export function getLoanDatePickerConstraints(listing?: Listing, isExistingLoan = false) {
  const constraints = getListingLoanDateConstraints(isExistingLoan ? undefined : listing);
  const preventsPastDates = isDonationListing(listing) || listing?.transactionMode === TransactionMode.sell;

  if (!preventsPastDates) return constraints;

  const today = startOfDay(new Date());
  const minimumDate =
    constraints.minimumDate && isBefore(today, constraints.minimumDate) ? constraints.minimumDate : today;

  return { ...constraints, minimumDate };
}
